import React from 'react';
import './Stepper.scss';

const Stepper = ({ step, maxStep, containerStyle }) => {

    return (
        <div className='stepper-wrapper' style={ containerStyle }>
            <div className='stepper'>
            <div className='step' style={{ width : `${step/maxStep*100}%` }}/>
            </div>
        </div>
    )
}

export default Stepper;